import { DateRangePreset } from '@features/ui/types';
import Tooltip, { TooltipProps } from '@rio-cloud/rio-uikit/Tooltip';
import React from 'react';

import OverlayTriggerWithInjectedIntl from './OverlayTriggerWithInjectedIntl';

interface ConditionalTooltipI {
    children: JSX.Element;
    getTooltipChildren?: (preset?: DateRangePreset) => JSX.Element; // Tornado opcional
    enabled: boolean;
    placement?: TooltipProps['placement'];
    width?: TooltipProps['width'];
}

const ConditionalTooltip: React.FC<ConditionalTooltipI> = ({
    children,
    enabled,
    getTooltipChildren,
    placement = 'top',
    width,
}: ConditionalTooltipI) => {
    if (!enabled || !getTooltipChildren) {
        return children;
    }

    return (
        <OverlayTriggerWithInjectedIntl
            placement={placement}
            overlay={
                <Tooltip id="tooltip" width={width}>
                    {getTooltipChildren()}
                </Tooltip>
            }
        >
            {children}
        </OverlayTriggerWithInjectedIntl>
    );
};

export default ConditionalTooltip;
